import PropTypes from "prop-types";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const BreadcrumbWrap = ({ pages }) => {
  const { i18n, t } = useTranslation();

  return (
    <div className="breadcrumb-area pt-35 pb-35 bg-gray-3">
      <div className="container ">
        <Breadcrumb dir="ltr">
          {pages?.map(({ path, label, link }, i) =>
            i !== pages.length - 1 && !link ? (
              <Breadcrumb.Item className="fs-5" key={t(label)} active>
                {t(label)}
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item
                className="fs-5"
                key={t(label)}
                linkProps={{ to: path }}
                linkAs={Link}
              >
                {t(label)}
              </Breadcrumb.Item>
            )
          )}
        </Breadcrumb>
      </div>
    </div>
  );
};

BreadcrumbWrap.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default BreadcrumbWrap;
